import { ReactNode } from "react";
import styles from "./DialogSurface.module.css";

type DialogSurfaceProps = {
  children: ReactNode;
  variant?: "regular" | "no-padding";
  className?: string;
};

function DialogSurface({
  children,
  variant = "regular",
  className,
}: DialogSurfaceProps) {
  const variantClassName =
    variant === "regular" ? styles.regular : styles["no-padding"];

  return (
    <div className={`${styles.surface} ${variantClassName} ${className ?? ""}`}>
      {children}
    </div>
  );
}

export default DialogSurface;
